import localforage from 'localforage';
import introjs from 'intro.js';

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

// TODO: Remove this or handle the scrolling because of the topnavbar
const handleAutoScroll = (intro) => intro.onafterchange(scrollToTop.bind(this));

export default {
  async mounted() {
    const initiallyEnabled = await localforage.getItem('enable_tour') ?? true;
    const demoSwitch = document.getElementById('demo-switch');

    if (!demoSwitch) return;

    demoSwitch.checked = initiallyEnabled;

    demoSwitch.addEventListener('change', async (e) => {
      await localforage.setItem('enable_tour', e.target.checked);
      if (e.target.checked) {
        this.pushEvent('tour_ready');
      }
    });

    this.handleEvent('run_intro', async ({ data }) => {
      const tourEnabled = await localforage.getItem('enable_tour') ?? true;
      if (!tourEnabled || !data.steps.length) {
        return;
      }
      console.debug(data.steps);
      const steps = data.steps.map((step) => ({
        ...step,
        element: step.variants?.sort((a, b) => b.width - a.width).find((element) => window.matchMedia(`(max-width: ${element.max_width}px)`).matches)?.element ?? step.element,
      }));
      let intro = introjs();
      intro = handleAutoScroll(intro);
      intro.setOptions({
        ...data.config,
        steps,
      }).start();
    });
    this.pushEvent('tour_ready');
  },
};
